import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MemberDetails, MemberQuery, MemberCard, MemberCardQuery, AuthService } from '@fgb/core';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'fgb-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
  animations: [
    trigger('rightNavAnimation', [
      state('open', style({ transform: 'translateX(0)', opacity: 1 })),
      state('close', style({ transform: 'translateX(100%)', opacity: 0.2 })),
      transition('open <=> close', [animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)')]),
    ]),
    trigger('rightMenuOverlayAnimation', [
      transition(':enter', [style({ opacity: 0 }), animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({ opacity: 1 }))]),
      transition(':leave', [style({ opacity: 1 }), animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({ opacity: 0 }))]),
    ]),
  ],
})
export class NavBarComponent implements OnInit, OnDestroy {
  isNavOpen = false;
  isHelpOpen = true;
  isCollapsed = false;
  memberDetails$!: Observable<MemberDetails | undefined>;
  card$!: Observable<MemberCard | undefined>;

  private readonly _destroyed$ = new Subject<void>();

  constructor(
    public router: Router,
    public memberQuery: MemberQuery,
    private authService: AuthService,
    private memberCardQuery: MemberCardQuery,
  ) {}

  ngOnInit() {
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.card$ = this.memberCardQuery.selectObservedMemberCard();
    this.initRouterListener();
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  private initRouterListener(): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this._destroyed$)
      )
      .subscribe(() => {
        this.isNavOpen = false;
      });
  }

  toggleSideNav(): void {
    this.isNavOpen = !this.isNavOpen;
  }

  logout() {
    firstValueFrom(this.authService.logout().pipe(tap(() => this.router.navigate(['/login']))));
  }
}
